/**
 * @generated SignedSource<<744099786b45c807158a3213f4de0222>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AppInfoType = "INFO" | "UPDATE" | "WARNING";
import { FragmentRefs } from "relay-runtime";
export type TeamAppInfoButton_appInfo$data = {
  readonly description: string | null;
  readonly linkURL: string;
  readonly title: string;
  readonly type: AppInfoType;
  readonly " $fragmentType": "TeamAppInfoButton_appInfo";
};
export type TeamAppInfoButton_appInfo$key = {
  readonly " $data"?: TeamAppInfoButton_appInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamAppInfoButton_appInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamAppInfoButton_appInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "AppInfo",
  "abstractKey": null
};

(node as any).hash = "e15bd2e1026cc5ea915691d55e1c7592";

export default node;
